<template>
  <div class="box-outer">
    <label v-if="label" :for="`id_${name}`" class="label">{{ label }}</label>
    <input
      :id="`id_${name}`"
      :type="type"
      :name="name"
      :min="min"
      :placeholder="placeholder"
      :value="value"
      :class="{ 'input-error': errors.length }"
      class="input"
      @input="handleInput"
      @blur="handleInput"
      @keydown="handleKeydown"
      @keyup="handleKeyUp"
    >
    <error-component :errors="errors"/>
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'

export default {
  components: {
    ErrorComponent
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleInput (evt) {
      this.$emit('input', evt.target.value)
    },
    handleKeydown (evt) {
      if (!evt.key.match('(\\d|Backspace|Delete|Tab|ArrowLeft|ArrowRight)')) {
        evt.preventDefault()
      }
    },
    handleKeyUp (evt) {
      if (evt.target.value.startsWith('0')) {
        evt.target.value = evt.target.value.substring(1, evt.target.value.length)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .box-outer {
    margin: 28px 0 0;
    .field &,
    .fields-wrap & {
      margin: 0;
    }
  }

  .label {
    @include label;
  }

  .input {
    @include input;
  }

  .input-error {
    border: 2px solid $error;
  }
</style>
